import AlertNotification, { type AlertNotificationType } from '@common/Toasts/AlertNotification';
import { toast, ToastOptions } from 'react-toastify';

import ErrorToast from '@/components/common/Toasts/ErrorToast';
import SuccessToast from '@/components/common/Toasts/SuccessToast';

import { COLORS } from '../constants';

export function showSuccessToast(message: string) {
  toast(<SuccessToast message={message} />, {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'colored',
    closeButton: false,
    progressStyle: {
      backgroundColor: COLORS.greenDark,
    },
  });
}

export function showErrorToast(message: string, ToastOptions: ToastOptions = {}) {
  toast(<ErrorToast message={message} />, {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'colored',
    closeButton: false,
    progressStyle: {
      backgroundColor: COLORS.redDark,
    },
    ...ToastOptions,
  });
}

export function showAlertNotification(message: string, type: AlertNotificationType) {
  toast(<AlertNotification message={message} type={type} />, {
    position: 'bottom-center',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'light',
    closeButton: false,
    className: 'alert-notification',
  });
}
